export const __DEV__ = process.env.NODE_ENV === 'development';
const __TEST__ = process.env.NODE_ENV === 'test';

export default {
    apiDomain: '',
    client_id: 'p',
    host: __DEV__ ? 'http://127.0.0.1:8088' : (__TEST__ ? 'http://10.5.11.27' : 'https://cpzy.mingyuanyun.com/'),
    neo: __DEV__ ? 'http://10.20.32.49.:8089/api' : (__TEST__ ? 'http://10.5.11.27:4200/api' : 'https://cpzy-api.mingyuanyun.com/api'),
    upgradeHost: __DEV__ ? 'http://upgrade-test.mingyuanyun.com' : (__TEST__ ? 'http://upgrade-test.mingyuanyun.com' : 'https://upgrade.mingyuanyun.com'),
    uploadPrefix: '/Upload/FileSave/',
    apiVersion: 'v1',

    // Oidc config
    VUE_APP_AUTHORITY: __DEV__ ? 'https://auth-test.mingyuanyun.com' : (__TEST__ ? 'https://auth-test.mingyuanyun.com' : 'https://auth.mingyuanyun.com'),
    VUE_APP_CLIENT_ID: __DEV__ ? 'cpmh-kfhj' : (__TEST__ ? 'cpmh-cshj' : '	cpmh-zshj'),
    VUE_APP_REDIRECT_URI: __DEV__ ? 'http://127.0.0.1:8088/CallBack' : (__TEST__ ? 'http://10.5.11.27:8000/CallBack' : 'https://cpzy.mingyuanyun.com/CallBack'),
    VUE_APP_POST_LOGOUT_REDIRECT_URI: __DEV__ ? 'http://127.0.0.1:8088' : (__TEST__ ? 'http://10.5.11.27:8000' : 'https://cpzy.mingyuanyun.com/'),
    VUE_APP_RESPONSE_TYPE: 'code',
    VUE_APP_SCOPE: 'openid offline_access profile defaultApi',
    VUE_APP_RESPONSE_MODE: 'query',
    tjHost: 'https://open.mingyuanyun.com',
    processurl: 'https://yxmgl.mingyuanyun.com/requirementManage/feedbackManage',
};
